const SECURITY_DISCLOSURE_CONTACT_EMAIL = 'security@raider.io';
const SECURITY_DISCLOSURE_POLICY_PATH = '/security';
const SECURITY_DISCLOSURE_LEGACY_METADATA_PATH = '/security.txt';
const SECURITY_DISCLOSURE_METADATA_PATH = '/.well-known/security.txt';
const SECURITY_DISCLOSURE_POLICY_URL = `https://raider.io${SECURITY_DISCLOSURE_POLICY_PATH}`;
const SECURITY_DISCLOSURE_CANONICAL_URL = `https://raider.io${SECURITY_DISCLOSURE_METADATA_PATH}`;
const SECURITY_DISCLOSURE_PREFERRED_LANGUAGES = 'en';

const SIX_MONTHS_IN_MS = 180 * 24 * 60 * 60 * 1000;

export {
  SECURITY_DISCLOSURE_CANONICAL_URL,
  SECURITY_DISCLOSURE_CONTACT_EMAIL,
  SECURITY_DISCLOSURE_LEGACY_METADATA_PATH,
  SECURITY_DISCLOSURE_METADATA_PATH,
  SECURITY_DISCLOSURE_POLICY_PATH,
  SECURITY_DISCLOSURE_POLICY_URL,
  SECURITY_DISCLOSURE_PREFERRED_LANGUAGES
};

export function buildSecurityTxt(expiresAt = new Date(Date.now() + SIX_MONTHS_IN_MS).toISOString()): string {
  return (
    [
      `Contact: mailto:${SECURITY_DISCLOSURE_CONTACT_EMAIL}`,
      `Policy: ${SECURITY_DISCLOSURE_POLICY_URL}`,
      `Canonical: ${SECURITY_DISCLOSURE_CANONICAL_URL}`,
      `Expires: ${expiresAt}`,
      `Preferred-Languages: ${SECURITY_DISCLOSURE_PREFERRED_LANGUAGES}`
    ].join('\n') + '\n'
  );
}
